/**
 * Save/unsave control on an activity card (TRAV23 activities-front merge).
 *
 * RSI already exports a `SavedProperty` for hotels/condos that posts to
 * `/identity/users/saved-property`; this one drives the activity collection behind
 * `Urls.ActivitySavedProperty`, so it is a separate component rather than a shared one.
 */

import { AppDispatch, RootState } from '@share/utils';
import React, { useState } from 'react';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import { IActivity } from '@common-types';
import { activitySavedPropertyActions } from '@share/store/slices';
import './style.scss';
import { Spin } from 'antd/lib';
import { IAccount } from '@share/common-types';

interface Props {
  activity: IActivity;
}

export const ActivitySavedProperty: React.FC<Props> = ({ activity }) => {
  const dispatch = useDispatch<AppDispatch>();
  const savedIds = useSelector((state: RootState) => state.activitySavedPropertyStore.savedIds);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const siteId = Number(loginStore?.user?.userAdditionalData?.siteID);
  const organizationId = Number(  loginStore?.user?.userAdditionalData?.organizationId);

  const account = loginStore?.account as IAccount;
  const displaySavedProperties = account?.displaySavedProperties;

  const siteIds = (account?.displaySavedPropertiesRsiSiteidList || []).map(Number);
  const orgIds = (account?.displaySavedPropertiesRsiOrgidList || []).map(Number);

  const hasSiteIds = siteIds.length > 0;
  const hasOrgIds = orgIds.length > 0;

  let isAllowed = false;

  if (hasSiteIds && hasOrgIds) {
    isAllowed = siteIds.includes(siteId) && orgIds.includes(organizationId);
  } else if (hasOrgIds) {
    isAllowed = orgIds.includes(organizationId);
  } else if (hasSiteIds) {
    isAllowed = siteIds.includes(siteId);
  } else {
    isAllowed = true;
  }

  const hasSavedPropertieEnable = Boolean( displaySavedProperties && isAllowed );

  if (!hasSavedPropertieEnable) {
    return null;
  }

  const isSaved = savedIds.includes(activity?.code);
  const [loading, setLoading] = useState(false);
  
  const onFavoriteClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (loading) return;
    dispatch(activitySavedPropertyActions.toggleLocalSaved(activity.code));
    const payload = {
      activityCode: activity?.code,
      address: activity?.content?.startingPoints?.[0]?.address || activity?.content?.travelerPickups?.[0]?.address || '',
      imgSrc: activity?.content?.mediaImages?.[0]?.resource || '',
      name: activity?.name,
      rating: activity?.reviews?.averageRating || 0,
      reviewsCount: activity?.reviews?.total || 0,
      type: 'activity',
    };
      setLoading(true);
      try {
        await dispatch(activitySavedPropertyActions.saveActivity({payload, isSaved}));
      } catch (error) {
        console.error('Failed to save property:', error);
        dispatch(activitySavedPropertyActions.toggleLocalSaved(activity.code));
      } finally {
        setLoading(false);
      }
  };

  return (
      <div className="activity-card-wrapper__favorite-button" onClick={onFavoriteClick} >
        {loading ? (
          <Spin />
        ) : isSaved ? (
          <HeartFilled style={{ color: '#ff4d4f' }} />
        ) : (
          <HeartOutlined />
        )}
      </div>


  );
};

